export const accessAreaBranches = {
    AREA: 'AREA',
    CONTROLLER: "CONTROLLER",
    ZONE: "ZONE",
    LOCATION: "LOCATION"
}

/**
 * 1 = Access Area
 * 2 = Lift Area
 * null = all types
 */
export type AREA_TYPE =  1 | 2 | null;

/**
 * 1 = Access Group
 * 2 = Floor Group
 * null = all types
 */
export type GROUP_TYPE = 1 | 2 | null;